import { render, staticRenderFns } from "./warmfilter.vue?vue&type=template&id=2f1732e5&scoped=true&"
import script from "./warmfilter.vue?vue&type=script&lang=js&"
export * from "./warmfilter.vue?vue&type=script&lang=js&"
import style0 from "./warmfilter.vue?vue&type=style&index=0&id=2f1732e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1732e5",
  null
  
)

export default component.exports